import { createApp } from 'vue';
import './CountrySwitcher-entry.scss';
import CountrySwitcherModal from './CountrySwitcherModal.vue';

const mountCountrySwitcher = () => {
	const countrySwitcherBlock = document.getElementById(
		'country-switcher-mount'
	);

	if (!countrySwitcherBlock) {
		return;
	}

	const switcherApp = createApp({
		name: 'country-switcher-block',
	});

	switcherApp.component('country-switcher-modal', CountrySwitcherModal);
	switcherApp.mount(countrySwitcherBlock);
};

mountCountrySwitcher();